// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "../rel/stylesheet/" + {"474":"psdl-eherkenning-couple","562":"flextool","727":"customer","862":"handsontable","890":"psdl-eherkenning-login"}[chunkId] + "-core-min.css";
};